import { IconProps, iconA11yProps } from '../types';

export const Reference = ({ classNames, label }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={classNames} {...iconA11yProps(label)}>
        <path d="M5 9l14 0" /><path d="M5 15l14 0" /><path d="M11 4l-4 16" /><path d="M17 4l-4 16" />
    </svg>
);
